<template>
  <v-container class="main-container responsive-height create-investor-account-details">
    <v-row dense>
      <v-col cols="12" sm="4" md="4" lg="3">
        <v-card tile flat class="TitleCard mb-3" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-sheet class="mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <h2 class="mt-0">Investor Acc No.</h2>
                  <p class="mb-0">{{ managerAccount }}</p>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row dense>
          <v-col cols="12">
            <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
              <div class="user-profile">
                <div class="profile-image">
                  <v-avatar size="47">
                    <v-img
                      :src="investorstatistics?.data.profile_pic_url || require('@/assets/avatar.png')"></v-img>
                  </v-avatar>
                </div>
                <v-btn small class="mt-3" elevation="0" plain>
                  <router-link
                    :to="`/registered-user-details/${investorstatistics?.data.client_account_id}`"
                    class="text-capitalize text--primary">
                    {{ investorFullName }}
                  </router-link>
                </v-btn>
              </div>
              <div class="profile-text">
                
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="8" md="8" lg="5">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span>Total Clients</span>
                    <p class="number mb-0">{{ investorstatistics?.data.total_acc }} <strong>ACC.</strong></p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">Credit: </span>
                    <b class="ml-1">{{ investorstatistics?.data.Credit || 0 }}</b>
                    <br />
                    <span class="mb-2 d-inline-block">Leverage: </span>
                    <b class="ml-1">{{ investorstatistics?.data.leverage || 0 }}</b>
                  </p>

                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span class="ml-0">Account Balance</span>
                    <p class="number mb-0">{{ investorstatistics?.data.Balance || 0 }} <strong>USD</strong></p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <span class="equity">
                    <span class="mb-2 d-inline-block">Equity: </span> <b class="ml-1">{{ investorstatistics?.data.Equity || 0
                    }}</b>
                    <br />
                    <span class="mb-2 d-inline-block">Currency: </span> <b class="ml-1">USD</b>
                  </span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <InvestorDetailsAllTabs></InvestorDetailsAllTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InvestorDetailsAllTabs from '@/components/Mam/TradeMasterInvestorDetailsAllTab.vue';

import { TRADEMASTER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: '',
      managerAccount: '',
    };
  },

  components: {
    InvestorDetailsAllTabs
  },

  computed: {
    ...mapState("trademaster", ["investorstatistics"]),

    investorFullName() {
      const data = this.investorstatistics?.data;
      if (!data?.fname && !data?.lname) return 'No Name';
      return `${data.fname || ''} ${data.lname || ''}`.trim();
    }
  },

  methods: {
    ...mapActions("trademaster", [TRADEMASTER__ACTIONS.GETRADEMASTERINVESTORSTATISTICS]),

  },

  async mounted() {
    this.managerAccount = this.$route.query.account;
    const parameters = {
      account: this.managerAccount,
      search: this.search,
    }
    await this[TRADEMASTER__ACTIONS.GETRADEMASTERINVESTORSTATISTICS](parameters);
  }
}
</script>
